<template>
    <div class="box">
        <headerPage/>
        <div class="boxTop">
            <div class="img">
                <img :src="user.mthumb" alt="">
            </div>
            <div class="name">{{ user.mnickname }}</div>
        </div>
        <div class="boxCenter">
            <div class="title-box">
                <b>填写入驻信息</b>
                <p @click="$router.go(-1)">
                    <img alt="" src="../../assets/images/back.png">
                    返回
                </p>
            </div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="100px">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="专家照片">
                            <div class="img-box">
                                <el-upload
                                    ref="upload"
                                    :action="fileUpUrl"
                                    :before-upload="beforeAvatarUpload"
                                    :on-error="uploadError"
                                    :on-success="(response,file)=>uploadSuccess(response,file,1)"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpeg"
                                    class="avatar-uploader">
                                    <img v-if=" ruleForm.img != ''" :src="urlStr + ruleForm.img" alt="">
                                    <img v-else alt="" src="../../assets/images/moren.png">
                                </el-upload>
                                <span class="moren" @click="ruleForm.img = ''">设为默认头像</span>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="ruleForm.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别">
                            <el-select v-model="ruleForm.sex" placeholder="请选择性别" style="width: 100%;">
                                <el-option label="男" value="1"></el-option>
                                <el-option label="女" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="领域" prop="lingyu">
                           <div class="flex">
                               <el-select v-model="ruleForm.cate" placeholder="请选择分类"
                                          style="width: 100%;" @change="getExpertType">
                                   <el-option
                                       v-for="item in cate_lists"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                                   </el-option>
                               </el-select>
                               <el-select v-model="ruleForm.lingyu" class="margin-left-xs" placeholder="请选择" style="width: 100%;">
                                   <el-option
                                       v-for="item in options"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                                   </el-option>
                               </el-select>
                           </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="政治面貌">
                            <el-input v-model="ruleForm.mianmao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="出生日期">
                            <el-date-picker
                                v-model="ruleForm.date"
                                placeholder="选择日期"
                                style="width: 100%;"
                                type="date" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学历">
                            <el-input v-model="ruleForm.xueli"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="民族">
                            <el-input v-model="ruleForm.minzu"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="通讯地址">
                            <el-input v-model="ruleForm.address"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="身份证号">
                            <el-input v-model="ruleForm.idcard"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作单位">
                            <el-input v-model="ruleForm.danwei"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="身份证正面">
                            <div class="flex">
                                <div v-if="ruleForm.id_card" class="flex justify-start align-center">
                                    <a :href="urlStr + ruleForm.id_card" class="margin-right-xs" target="_blank">
                                        <el-button>查看正面</el-button>
                                    </a>
                                    <el-button class="margin-right-xs" icon="el-icon-delete" type="danger" @click="ruleForm.id_card = ''"></el-button>
                                </div>
                                <el-upload
                                    ref="upload"
                                    :action="fileUpUrl"
                                    :before-upload="beforeAvatarUpload"
                                    :on-error="uploadError"
                                    :on-success="(response,file)=>uploadSuccess(response,file,2)"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpeg"
                                    class="avatar-uploader">
                                    <el-button type="primary">上传身份证正面</el-button>
                                </el-upload>

                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证反面">
                            <div class="flex">
                                <div v-if="ruleForm.id_card_two" class="flex justify-start align-center">
                                    <a :href="urlStr + ruleForm.id_card_two" class="margin-right-xs" target="_blank">
                                        <el-button>查看反面</el-button>
                                    </a>
                                    <el-button class="margin-right-xs" icon="el-icon-delete" type="danger" @click="ruleForm.id_card_two = ''"></el-button>
                                </div>

                                <el-upload
                                    ref="upload"
                                    :action="fileUpUrl"
                                    :before-upload="beforeAvatarUpload"
                                    :on-error="uploadError"
                                    :on-success="(response,file)=>uploadSuccess(response,file,3)"
                                    :show-file-list="false"
                                    accept="image/png,image/gif,image/jpeg"
                                    class="avatar-uploader">
                                    <el-button type="primary">上传身份证反面</el-button>
                                </el-upload>
                            </div>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-form-item label="资质证书">
                            <div class="flex">
                                <!--                <a :href="urlStr + ruleForm.cert" v-if="ruleForm.cert" target="_blank" class="margin-right-xs"><el-button>查看证书</el-button></a>-->
                                <el-upload
                                    ref="upload"
                                    :action="fileUpUrl"
                                    :before-upload="beforeAvatarUpload"
                                    :file-list="ruleForm.cert"
                                    :on-error="uploadError"
                                    :on-remove="(file,fileList)=>uploadRemove(file,fileList,4)"
                                    :on-success="(response,file)=>uploadSuccess(response,file,4)"
                                    :show-file-list="true"
                                    accept="*"
                                    class="avatar-uploader">
                                    <el-button type="primary">上传资质证书</el-button>
                                </el-upload>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="开户银行">
                            <el-input v-model="ruleForm.open_bank"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开户账号">
                            <el-input v-model="ruleForm.bank_number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="ruleForm.phone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职称">
                            <el-input v-model="ruleForm.zhicheng"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="所属行业">
                            <el-input v-model="ruleForm.hangye"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col v-for="(domain,index) in ruleForm.zhiwu" :key="domain.key" :span="12">
                        <el-form-item
                            label="职务"
                        >
                            <div class="flex justify-start align-center">
                                <el-input v-model="domain.value"></el-input>
                                <el-button v-if="index === 0" class="add" @click="addDomain">添加</el-button>
                                <el-button v-else class="add" @click.prevent="removeDomain(domain)">删除</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="简介" prop="content">
                            <ck-decoupled-editor ref="editor" :content="ruleForm.content"></ck-decoupled-editor>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input v-model="ruleForm.remark" type="textarea"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <div class="flex justify-center">
                        <span class="btn3" @click="submitForm('ruleForm')">提交</span>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <footerPage/>
    </div>
</template>

<script>
import headerPage from '../home/common/headPage'
import footerPage from '../home/common/footPage'
import CkDecoupledEditor from "@/components/CKDecoupledEditor";
import {fileUpUrl, IMAGE_PATH} from "@/config";
import {checkName, getExpertCate, getExpertTypeTwo, sub} from "@/api";

export default {
    name: "checkin",
    data() {
        return {
            register_type: 3,
            showId: '',
            fileUpUrl: fileUpUrl,
            urlStr: IMAGE_PATH,
            ruleForm: {
                img: '',
                name: '',
                sex: '',
                cate: '',
                lingyu: '',
                mianmao: '',
                date: '',
                xueli: '',
                minzu: '',
                address: '',
                idcard: '',
                danwei: '',
                open_bank: '',
                bank_number: '',
                id_card: '',
                id_card_two: '',
                cert: [],
                phone: '',
                zhicheng: '',
                hangye: '',
                zhiwu: [{
                    value: ''
                }],
                content: '',
                remark: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入姓名', trigger: 'blur'},
                ],
                lingyu: [
                    {required: true, message: '请输入领域', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '请输入简介', trigger: 'change'},
                ],
                phone: [
                    {required: true, message: '请输入手机号', trigger: 'blur'},
                ],
            },
            cate_lists: [],
            options: [],
        }
    },
    components: {
        headerPage,
        footerPage,
        CkDecoupledEditor
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.register_type = this.$route.query.register_type
        this.showId = this.$route.query.showId
        this.init()
    },
    methods: {
        async init(){
            let _data = await getExpertCate(this.showId)
            this.cate_lists = _data.data
        },
        submitForm(formName) {
            let _info = this.$refs.editor.getInfo()
            this.ruleForm.content = _info.content
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.checkName()
                } else {
                    this.$message.error('请填写完整..');
                    return false;
                }
            });
        },

        // 获取专家领域
        async getExpertType() {
            this.ruleForm.lingyu = ''
            this.options = []
            let _res = await getExpertTypeTwo(
                this.showId,
                this.ruleForm.cate
            );
            if (_res.status === 200) {
                this.options = _res.data
            } else {
                this.$message.error(_res.msg);
            }
        },

        async checkName() {
            let _res = await checkName(
                this.user.mid,
                this.ruleForm.name
            );
            if (_res.status === 200) {
                if (_res.data.is_check == 1) {
                    this.$message.success(_res.msg);
                    this.$confirm('专家姓名已存在，是否继续提交?', '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.sub()
                    }).catch(() => {

                    });

                } else {
                    this.sub()
                }
            } else {
                this.$message.error(_res.msg);
            }
        },

        // 提交信息
        async sub() {
            let _res = await sub(
                this.showId,
                this.register_type,
                this.ruleForm.img,
                this.ruleForm.name,
                this.ruleForm.sex,
                this.ruleForm.cate,
                this.ruleForm.lingyu,
                this.ruleForm.mianmao,
                this.ruleForm.date,
                this.ruleForm.xueli,
                this.ruleForm.minzu,
                this.ruleForm.address,
                this.ruleForm.idcard,
                this.ruleForm.danwei,
                this.ruleForm.phone,
                this.ruleForm.zhicheng,
                this.ruleForm.hangye,
                this.ruleForm.zhiwu.length > 0 ? JSON.stringify(this.ruleForm.zhiwu) : [],
                this.ruleForm.content,
                this.ruleForm.remark,
                this.ruleForm.open_bank,
                this.ruleForm.bank_number,
                this.ruleForm.id_card,
                this.ruleForm.id_card_two,
                this.ruleForm.cert.length > 0 ? JSON.stringify(this.ruleForm.cert) : [],
            );
            if (_res.status === 200) {
                this.$message.success(_res.msg);
                this.$router.back()
            } else {
                this.$message.error(_res.msg);
            }
        },

        removeDomain(item) {
            var index = this.ruleForm.zhiwu.indexOf(item)
            if (index !== -1) {
                this.ruleForm.zhiwu.splice(index, 1)
            }
        },
        addDomain() {
            this.ruleForm.zhiwu.push({
                value: '',
                key: Date.now()
            });
        },
        // s删除列表文件
        uploadRemove(file, fileList) {
            this.ruleForm.cert = fileList
        },

        //  上传成功
        uploadSuccess(response, file, type) {
            this.uping.close();
            if (response.status === 200) {
                if (type == 1) {
                    this.ruleForm.img = response.data.url
                }
                if (type == 2) {
                    this.ruleForm.id_card = response.data.url
                }
                if (type == 3) {
                    this.ruleForm.id_card_two = response.data.url
                }
                if (type == 4) {
                    this.ruleForm.cert.push({
                        name: file.name,
                        url: response.data.url
                    })
                }
            } else {
                this.$message.success(response.msg)
            }
        },
        //  上传失败
        uploadError() {
            this.uping.close();
            this.$message({
                message: "上传出错，请重试！",
                type: "error",
                center: true,
            });
        },

        beforeAvatarUpload() {
            // console.log(file)
            // console.log(type)
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isLt2M) {
            //   this.$message.error('上传头像图片大小不能超过 2MB!');
            // }

            this.uping = this.$loading({
                lock: true,
                text: "上传中，请稍后",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.2)",
            });
        },

        // 跳转
        to(path) {
            this.$router.push(path)
        },
    },
    watch: {
        "ruleForm.cert"() {
            console.log(this.ruleForm.cert)
        }
    }
}
</script>

<style lang="scss" scoped>

.box {
    width: 100%;
    background-color: #f2f3f4;

    .boxTop {
        width: 100%;
        height: 100px;
        background-color: #18314f;
        margin-top: -2px;
        padding-top: 60px;

        .name {
            width: 100%;
            text-align: center;
            font-size: 24px;
            letter-spacing: 1px;
            color: #333333;
            font-weight: bold;
            padding-top: 10px;
        }

        .img {
            width: 80px;
            height: 80px;
            border-radius: 40px;
            overflow: hidden;
            background-color: #ffffff;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
                object-fit: scale-down;
            }
        }
    }

    .boxCenter {
        width: 1211px;
        padding: 0 25px;
        margin: 0 auto;
        margin-top: 120px;
        background-color: #ffffff;
        padding-bottom: 20px;
        margin-bottom: 50px;

        .title-box {
            width: 100%;
            height: 80px;
            border-bottom: 1px solid #f3f3f3;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;

            p {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 80px;
                height: 30px;
                font-size: 14px;
                letter-spacing: 1px;
                color: #0a2240;
                cursor: pointer;

                img {
                    width: 15px;
                    margin-right: 5px;
                }
            }

            b {
                font-size: 20px;
                letter-spacing: 1px;
                color: #333333;
                font-weight: bold;
            }
        }
    }
}

.add {
    width: 70px;
    height: 40px;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-size: 14px;
    text-align: center;
    line-height: 38px;
    cursor: pointer;
    border-radius: 4px;
    margin-left: 5px;
    padding: 0;
}

.btn1 {
    width: 120px;
    height: 40px;
    background-color: #0a2240;
    border-radius: 20px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.btn2 {
    width: 120px;
    height: 40px;
    background-color: #ffffff;
    border-radius: 20px;
    border: solid 1px #0a2240;
    font-size: 14px;
    color: #0a2240;
    text-align: center;
    line-height: 38px;
    cursor: pointer;
    margin-right: 20px;
}

.btn3 {
    width: 120px;
    height: 40px;
    background-color: #ff9600;
    border-radius: 20px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.img-box {
    width: 125px;
    max-height: 164px;
    border-radius: 10px;
    border: 1px solid #0a2240;
    position: relative;
    //overflow: hidden;
    margin-bottom: 20px;

    img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        object-fit: scale-down;
    }

    .upload-demo {
        width: 100%;
        height: 100%;
    }

    .moren {
        display: block;
        line-height: 30px;
        font-size: 12px;
        background-color: #0a2240;
        color: #ffffff;
        width: 125px;
        text-align: center;
        border-radius: 3px;
        position: absolute;
        bottom: -36px;
        right: 0;
        z-index: 300;
        cursor: pointer;
    }
}

</style>
